import clients from './clients'
import contracts from './contracts'
import objects from './objects'
import references from './references'
import sms from './sms'
import finance from './finance'
import administration from './administration'
import reports from './reports'

export default [
  ...objects,
  ...clients,
  ...contracts,
  ...finance,
  ...references,
  ...sms,
  ...administration,
  ...reports,
]
